import { FormValidations } from "features/shared/forms/hooks/useForm";
import { getFileExtensionValidationMessage, getSingleFileValidationMessage } from "features/shared/helpers/translationHelper";
import FilesValidationRule from "features/validation/rules/FilesValidationRule";
import { TFunction } from "i18next";

export const fileUploadSubDialogValidations = (t: TFunction): FormValidations => {
  return {
    uploadedFile: {
      required: true,
      type: "Files",
      filesCount: 1,
      message: `${getSingleFileValidationMessage(t)} ${getFileExtensionValidationMessage(t)}`
    } as FilesValidationRule
  };
};